import React from 'react';
import { UiInputProps, UiInput } from '@open-stack/ui';
import clsx from 'clsx';
import { XButton } from '../button/XButton';
import styled from 'styled-components';

const Wrapper = styled.div`
    label {
        background-color: var(--ui-color-input);
        border-radius: var(--input-border-radius) !important;
    }

    input {
        font-size: var(--UiText-font-size-1);
        padding: 0;
        margin: 0;
    }

    &:not(.iconStart) input {
        padding-left: calc(2 * var(--ui-spacing));
    }

    .UiIconMaterial {
        color: var(--x-color-text-secondary);
    }

    .UiInput:not(.type-textarea).size-0 .input-container,
    .UiInput:not(.type-textarea).size-0 .input-container input,
    .UiInput:not(.type-textarea).size-0 .input-container select {
        height: var(--button-input-height);
    }
`;

type Props = UiInputProps & {
    iconStart?: string;
    iconEnd?: string;
};

export function XInput({ iconStart, iconEnd, ...rest }: Props) {
    if (iconStart) {
        rest.adornmentStart = <XButton icon={iconStart} variant="text" />;
    }

    if (iconEnd) {
        rest.adornmentEnd = <XButton icon={iconEnd} variant="text" />;
    }

    return (
        <Wrapper className={clsx('XInput', { iconStart, iconEnd })}>
            <UiInput {...rest} />
        </Wrapper>
    );
}
